// Магазин работает строго по МСК (UTC+3). Админ может зайти из любого часового
// пояса, но все слот-расчёты и cutoff'ы должны быть в МСК.

export function nowMSK() {
  const utcStr = new Date().toLocaleString('en-US', { timeZone: 'Europe/Moscow' });
  return new Date(utcStr);
}

export function currentHourMSK() {
  return nowMSK().getHours();
}

export function currentMinutesMSK() {
  return nowMSK().getMinutes();
}

export function todayMSK() {
  const n = nowMSK();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}

export function todayMSKString() {
  return ymdLocal(todayMSK());
}

/**
 * YYYY-MM-DD произвольной даты по ЛОКАЛЬНЫМ компонентам (getFullYear/Month/Date),
 * без перевода в UTC. Использовать вместо date.toISOString().slice(0,10) —
 * последний ночью по МСК отдаёт вчерашний день (UTC отстаёт на 3 часа).
 */
export function ymdLocal(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
